import { FlexBox } from "@brg/ui";

import AuthorsSelect from "./AuthorsSelect";

const PresentationAuthorsSelect = () => {
  return (
    <FlexBox
      direction={'column'}
      directionMobile='column'
      offsetBottom={24}
      width={'100%'}
      widthMobile={'100%'}
      className='coauthors-container'
    >
      <AuthorsSelect isPresentation />
    </FlexBox>
  );
};

export default PresentationAuthorsSelect;import { FlexBox } from "@brg/ui";

import AuthorsSelect from "./AuthorsSelect";

const PresentationAuthorsSelect = () => {
  return (
    <FlexBox
      direction={'column'}
      directionMobile='column'
      offsetBottom={24}
      width={'100%'}
      widthMobile={'100%'}
      className='coauthors-container'
    >
      <AuthorsSelect isPresentation />
    </FlexBox>
  );
};

export default PresentationAuthorsSelect;